var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"scrollable":"","persistent":"","fullscreen":_vm.$vuetify.breakpoint.xs,"width":_vm.$vuetify.breakpoint.thresholds.sm},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('WikiProposalsCore',{attrs:{"value":_vm.value},on:{"close":_vm.handleClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }